import React from 'react';
import { ICandidateSourcingPool, TEmail } from './types';
import { CandidateSourcingAction } from './candidateSourcingReducer';
import CandidateSourcingEmailAnalytics from './CandidatePools/CandidateSourcingEmailAnalytics';
import IndividualCandidatePoolModal from './CandidatePools/IndividualCandidatePoolModal';

interface WithPoolModalProps {
  candidatePoolModalHook: {
    isModalOpen: boolean;
    selectedPool: ICandidateSourcingPool | undefined;
    individualCandidatePoolsState: any;
    individualCandidatePoolsDispatch: any;
    emailsState: any;
    emailsDispatch: any;
    modalTabValue: number;
    setModalTabValue: (tabValue: number) => void;
    handleCloseModal: () => void;
    handleSnackbarState: (snackbarState: any) => void;
    candidateSourcingState: {
      selectedEmailForAnalytics: (TEmail & { poolId: number }) | null;
    };
    candidateSourcingDispatch: React.Dispatch<CandidateSourcingAction>;
  };
  children: React.ReactNode;
  refetch?: () => void;
}

const WithPoolModal: React.FC<WithPoolModalProps> = ({ candidatePoolModalHook, refetch, children }) => {
  const {
    candidateSourcingState,
    candidateSourcingDispatch,
    isModalOpen,
    selectedPool,
    individualCandidatePoolsState,
    individualCandidatePoolsDispatch,
    emailsState,
    emailsDispatch,
    handleCloseModal,
    handleSnackbarState,
    modalTabValue,
    setModalTabValue
  } = candidatePoolModalHook;
  const { selectedEmailForAnalytics } = candidateSourcingState;

  if (selectedEmailForAnalytics && isModalOpen && selectedPool) {
    return (
      <CandidateSourcingEmailAnalytics
        selectedEmail={selectedEmailForAnalytics}
        emailsDispatch={candidateSourcingDispatch}
        selectedPoolId={selectedEmailForAnalytics?.poolId}
      />
    );
  }

  return (
    <>
      {children}
      {selectedPool && (
        <IndividualCandidatePoolModal
          isOpen={isModalOpen}
          selectedPool={selectedPool}
          individualCandidatePoolsState={individualCandidatePoolsState}
          individualCandidatePoolsDispatch={individualCandidatePoolsDispatch}
          emailsState={emailsState}
          emailsDispatch={emailsDispatch}
          handleClose={handleCloseModal}
          setSnackbarState={handleSnackbarState}
          refetch={refetch || (() => false)}
          modalTabValue={modalTabValue}
          setModalTabValue={setModalTabValue}
          candidateSourcingDispatch={candidateSourcingDispatch}
        />
      )}
    </>
  );
}

export default WithPoolModal;
